export function isEqualPath(
  targetPath: PropertyKey[],
  sourcePath: PropertyKey[]
) {
  if (targetPath.length !== sourcePath.length) return false
  for (const [i, element] of targetPath.entries()) {
    if (element !== sourcePath[i]) return false
  }
  return true
}
